module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAxCAMAAABqB5C8AAAAQlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////8IX9KGAAAAFXRSTlMAF/MsI7LNujjTEQ3YxakewAraoj3//XC+AAAAn0lEQVQ4y83Vyw6EIAyFYRgRVGRgLrz/q8522pykTbvQs/7S38REA1zfyL4Qxfb431wRSnmSlYhyHB0aFK25tIMcRPKlS3OrClUrWk6GDoTempzqkglVL/LnwqDoCVHIHMnqjEGh5qdiVdhzvaBKu41VmfmjGb4kvqhjnbPqjsrXOr4mf7lwVMc6Z75oM7FxI9YZawlfG/SfVgJmC9n2A5F7OePgtcLmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/back.png
// module id = akd5
// module chunks = 1